import NextStepsPage from '@components/NextStepsPage/NextStepsPage';

const NextSteps = () => {
  return (
    <>
      <NextStepsPage />
    </>
  );
};

export default NextSteps;
